module.exports = __webpack_public_path__ + "media/3x/E-cee2ac56.png";